import { render, staticRenderFns } from "./Fam.vue?vue&type=template&id=35e7c733&scoped=true&lang=pug"
import script from "./Fam.vue?vue&type=script&lang=js"
export * from "./Fam.vue?vue&type=script&lang=js"
import style0 from "./Fam.vue?vue&type=style&index=0&id=35e7c733&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e7c733",
  null
  
)

export default component.exports